var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcHospital = function SvgIcHospital(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.125,
    d: "M3.188 3.188h11.625v11.625H3.188z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.9 5.25c.124 0 .225.1.225.225v2.4h2.4c.124 0 .225.1.225.225v1.8c0 .124-.1.225-.225.225h-2.4v2.4c0 .124-.1.225-.225.225H8.1a.225.225 0 0 1-.225-.225v-2.4h-2.4A.225.225 0 0 1 5.25 9.9V8.1c0-.124.1-.225.225-.225h2.4v-2.4c0-.124.1-.225.225-.225z"
  })));
};
export default SvgIcHospital;